module.exports = __webpack_public_path__ + "static/media/logo.518d5890.svg";